import type { ReactElement } from 'react';
import { ExternalLink } from 'lucide-react';
import type { RunningNowListItem } from '@kirin/api-client/contracts/shadow-ai-running-now';
import { LoggedInUserText } from '../LoggedInUserText';

export function LoggedInUserCell({
  row,
}: {
  row: RunningNowListItem;
}): ReactElement {
  return (
    <LoggedInUserText
      email={row.loggedInUserEmail}
      match={row.loggedInUserMatch}
    />
  );
}

export {
  ToolNameCell,
  CategoryCell,
  PidCell,
  PortCell,
  StartedAtCell,
} from '@/components/shared/shadow-ai';

interface UserCellProps {
  row: RunningNowListItem;
  /**
   * Omit on a surface already scoped to one user (the Shadow AI user-scope
   * page): the cell renders plain text instead of a link that goes nowhere.
   */
  onUserClick?: (
    userId: string,
    toolId: string,
    processId: string,
    userInfo?: { email?: string; name?: string }
  ) => void;
}

export function UserCell({ row, onUserClick }: UserCellProps): ReactElement {
  const displayName = row.userName || row.userEmail || row.userId;

  if (!onUserClick) {
    return <span className="text-sm text-muted-foreground">{displayName}</span>;
  }

  return (
    <button
      className="text-sm text-muted-foreground hover:text-foreground hover:underline flex items-center gap-1"
      onClick={e => {
        e.stopPropagation();
        onUserClick(row.userId, row.toolId, row.id, {
          email: row.userEmail ?? undefined,
          name: row.userName ?? undefined,
        });
      }}
    >
      {displayName}
      <ExternalLink className="h-3 w-3" />
    </button>
  );
}
